<router-outlet></router-outlet>
<app-loader></app-loader>


<!-- <div [ngStyle]="{ 'background-color': colorCode }"></div> -->